import React, { useEffect } from 'react'
import SplitPane from 'react-split-pane'
import Input from '../../views/Input/Input'
import Output from '../../views/Output/Output'

const TabletView = () => {

  useEffect(() => {
    const mediaClass = '-media-sm'
    document.documentElement.classList.remove('-media-xs', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }, [])

  return (
    <>
      <SplitPane defaultSize="50%" split="horizontal" minSize={30}>
          <Input />
          <Output />
      </SplitPane>
    </>
  )
}

export default TabletView
